import PropTypes from "prop-types";
import { ITXImage } from "components/ITXImage";

export const ITXPicture = ({
  className,
  picClassName,
  image,
  image_web,
  image_4k,
}) => {
  return (
    <picture className={picClassName}>
      {image_web?.url && (
        <source
          data-testid="source-web"
          srcSet={image_web.url}
          media="(min-width: 1024px)"
        />
      )}
      {image_4k?.url && (
        <source
          data-testid="source-4k"
          srcSet={image_4k.url}
          media="(min-width: 2048px)"
        />
      )}
      <ITXImage
        id={image.id}
        name={image.name}
        width={image.width}
        height={image.height}
        url={image.url}
        className={className}
      />
    </picture>
  );
};

ITXPicture.propTypes = {
  className: PropTypes.string,
  picClassName: PropTypes.string,
  image: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    isDark: PropTypes.bool,
    type: PropTypes.string,
  }).isRequired,
  image_web: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    isDark: PropTypes.bool,
    type: PropTypes.string,
  }),
  image_4k: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    isDark: PropTypes.bool,
    type: PropTypes.string,
  }),
};
